import * as React from 'react';
import { RadioSwitchItem } from './RadioSwitchItem';
import { IRadioItem } from '../../../models/IRadioItem';

type RadioSwitchProps = {
    className: string
    active: string
    radios: IRadioItem[]
    onChange: (item: IRadioItem) => void;
}

export function RadioSwitch({ className, radios, active, onChange }: RadioSwitchProps) {
    return <div className={`radio-switch ${className}`}>
        {
            radios.map(radio => {
                return <RadioSwitchItem
                    radio={radio}
                    key={radio.label}
                    active={active}
                    onChange={onChange} />;
            })
        }   </div>;
}
